<template>
  <div class="a-tab" v-show="active">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'v-tab',
  props: {
    title: {
      type: [String],
      required: true,
    },
    icon: [String],
  },
  data() {
    return {
      active: false,
      id: 0,
    };
  },
};
</script>
